import type { FC } from 'react'
import React from 'react'

import type { TConnectProps } from '../Connect'
import { Connect } from '../Connect'
import useHooks from './useHooks'

const Facebook: FC<TConnectProps> = props => {
  const { connected, disabled } = props
  const { handleConnect, loading } = useHooks(props)

  return (
    <Connect
      connected={connected}
      disabled={loading || disabled}
      onClick={handleConnect}
    />
  )
}

export default Facebook
